import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, shadows, spacing }) => ({
  card: {
    background: palette.primary.main,
    boxShadow: shadows["5"],
    color: palette.common.white,
    minWidth: spacing(10),
  },
  cardActions: {
    justifyContent: "flex-end",
    paddingRight: 10,
  },
  fullWidth: {
    width: "100%",
  },
}));
